import React, { useState } from "react";
import videoFile from "../assets/img/eduAdminHubProduct.mp4";
import { Link } from "react-router-dom";

const OnfocusSection = () => {
  const [showModal, setShowModal] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  //=================== main_return_function =============//
  return (
    <section
      id="onfocus"
      className="onfocus section dark-background font-[poppins]"
    >
      <div className="container-fluid p-0" data-aos="fade-up">
        <div className="row g-0">
          <div className="col-lg-6 video-play position-relative">
            <div onClick={openModal} className=" pulsating-play-btn z-0"></div>
          </div>
          <div className="col-lg-6">
            <div className="content lg:!py-20 lg:!pl-20 lg:!pr-4 d-flex flex-column justify-content-center h-100">
              <h3 className="display-4 fw-bold font-[poppins]">
                Discover EduAdminHub — The Smarter Way to
                <span className="font-[Playfair] ml-1 italic text-[#9bd66c]">
                  Manage Education
                </span>
                <div className=" w-14 h-1 bg-[#9bd66c] mb-2"></div>
              </h3>
              <p className="lead fst-italic">
                See how EduAdminHub, powered by Oethical Technology, helps
                educational institutions streamline operations, enhance
                productivity, and deliver exceptional experiences. Our
                innovative platform is designed to simplify management and
                support your growth.
              </p>
              <ul>
                <li className="mb-2">
                  <i className="bi bi-check-circle text-success me-2"></i>{" "}
                  <strong> Tailored for education:</strong> All-in-one platform
                  for effortless administration
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle text-success me-2"></i>{" "}
                  <strong> Future-ready technology:</strong> Boost efficiency
                  with intelligent, scalable tools
                </li>
                <li>
                  <i className="bi bi-check-circle text-success me-2"></i>{" "}
                  <strong> Trusted partnership: </strong> Dedicated support to
                  ensure your success
                </li>
              </ul>

              <Link to="/eduAdminHub" className="read-more align-self-start">
                <span>Explore EduAdminHub</span>
                <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <button
            className="absolute top-2 right-2 text-white text-2xl"
            onClick={closeModal}
          >
            ✖
          </button>
          <div
            className="relative bg-black max-w-3xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              src={videoFile}
              controls
              autoPlay
              className="w-full h-auto max-h-[80vh]"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </section>
  );
};

export default OnfocusSection;
